import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MoviecontentComponent } from './video/moviecontent.component';
import { SelectedComponent } from './selected/selected.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'content/selected', component: SelectedComponent },
  { path: 'content/movies/all', component: MoviecontentComponent },
  // otherwise redirect to home
  //{ path: '**', redirectTo: '/login2' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
